import { observable, action, makeAutoObservable  } from 'mobx'
import { fetchIllustrations, fetchIllustrationCollections } from '../services/ElementService';
import { PhotoElement } from './componentStore'

class IllustrationStore {

  constructor(errorStore, workAreaStore) {
    makeAutoObservable(this);
    this.errorStore = errorStore
    this.workAreaStore = workAreaStore
  }

  collections = []
  searchTerm = ''
  pageNo = 0
  loading = false
  fetched = false
  empty = false
  collectionLoading = false
  collectionsOnly = true
  selectedCollection = null

  increasePage(){
    this.pageNo += 1
  }

  async fetchIcons(collectionId) {
    try{
      const collection = this.collections.find(({ _id }) => _id === collectionId)
      if(!collection){
        return
      }
      if(collection.icons && collection.icons.length > 0){
        return
      }else{
        this.collectionLoading = true
        const { data } = await fetchIllustrations(collectionId)
        collection.icons = data.icons
      }
    }catch(err){
      console.log(err)
    }finally {
      this.collectionLoading = false
    }
  }

  async setSelectedCollection(id, close = false){
    if(close){
      this.collectionsOnly = true
      this.selectedCollection = null
      return
    }
    this.collectionsOnly = false
    this.selectedCollection = null
    this.selectedCollection = this.collections.find(({ _id }) => _id === id)
    await this.fetchIcons(id)
  }

  setInitFetch(status){
    this.fetched = status
  }

  async fetchCollections(searchTerm, reset = false){
    if(searchTerm !== this.searchTerm){
      this.searchTerm = searchTerm
      this.pageNo = 0
      this.collections = []
    }
    if(reset){
      this.pageNo = 0
      this.collections = []
      this.searchTerm = ''
    }
    try{
      this.loading = true
      const { data } = await fetchIllustrationCollections(this.searchTerm, this.pageNo)
      this.collections.push(...data.collections)
      this.empty = data.isEmpty
      this.fetched = true
      const slide = document.querySelector('.sidebar-slide.illustrations')
      const el = document.querySelector('.sidebar-slide.illustrations .slide-wrapper .illustrations')
      if(el.clientHeight < slide.clientHeight && !data.isEmpty){
        this.increasePage()
        this.fetchCollections(this.searchTerm)
      }
    }catch(err){
      console.log(err)
    }finally{
      this.loading = false
    }
  }



}

export default IllustrationStore